export default "__VITE_PUBLIC_ASSET__d88e807e__"